export default __webpack_public_path__ + "static/media/rings.c00bdd4d.png";